<template>
  <div class="login">
    <div>
      <div class="login-top" @click="goHome">
        <img src="@/assets/img/图层_1.png" alt="" />
      </div>
      <div class="login-centen">
        <img class="login-centen-img" src="@/assets/img/loginBg.png" alt="" />
        <!-- 密码登录 -->
        <div class="login-centen-right" v-if="is == 1">
          <div class="login-centen-right-title">
            {{ windowWidth() > 767 ? "登录" : "密码登录" }}
          </div>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
            <!-- has-feedback 是 a-form-model-item属性 作用是显示验证结果图标 -->
            <a-form-model-item prop="phone" :style="{
              'margin-bottom': windowWidth() > 767 ? '26px' : '11px',
            }">
              <div class="components-input-demo-presuffix">
                <a-input v-model="ruleForm.phone" placeholder="请输入手机号" allow-clear>
                  <img src="@/assets/img/圆角矩形_4.png" alt="" slot="prefix" />
                </a-input>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="password" :style="{
              'margin-bottom': 0,
            }">
              <div class="components-input-demo-presuffix">
                <a-input-password v-model="ruleForm.password" placeholder="请输入密码" allow-clear>
                  <img src="@/assets/img/形状_1.png" alt="" slot="prefix" />
                  <img src="@/assets/img/x_拷贝.png" alt="" slot="suffix" @click.stop="clearPassword" />
                </a-input-password>
              </div>
            </a-form-model-item>
          </a-form-model>
          <div class="handoff" style="padding-bottom: 0">
            <span @click.stop="Captcha">验证码登录</span>
            <span @click.stop="ForgotPassword" v-if="windowWidth() > 767">忘记密码?</span>
            <div class="login-centen-right-bottom" @click="goLogon" v-else>
              <span>没有账号？去</span>
              <span>注册</span>
            </div>
          </div>
          <div class="login-centen-right-button" @click.stop="login(true)">
            登录
          </div>
          <div class="login-centen-right-bottom" @click="goLogon" v-if="windowWidth() > 767">
            <span>没有账号？去</span>
            <span>注册</span>
          </div>
          <div class="login-centen-right-bottom" @click="ForgotPassword" v-else>
            <span style="cursor: pointer">忘记密码?</span>
          </div>
        </div>
        <!-- 验证码登录 -->
        <div class="login-centen-right" v-if="is == 2">
          <div class="login-centen-right-title">
            {{ windowWidth() > 767 ? "登录" : "验证码登录" }}
          </div>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
            <a-form-model-item prop="phone" :style="{
              'margin-bottom': windowWidth() > 767 ? '26px' : '11px',
            }">
              <div class="components-input-demo-presuffix">
                <a-input v-model="ruleForm.phone" placeholder="请输入手机号" allow-clear>
                  <img src="@/assets/img/圆角矩形_4.png" alt="" slot="prefix" />
                  <!-- 自定义的清除图标 -->
                  <!-- <img
                    src="@/assets/img/x_拷贝.png"
                    alt=""
                    slot="suffix"
                    @click.stop="clearPhone"
                    style="cursor: pointer"
                  /> -->
                </a-input>
              </div>
            </a-form-model-item>
          </a-form-model>
          <div class="components-input-demo-presuffix">
            <a-input v-model="code" placeholder="请输入验证码">
              <img src="@/assets/img/形状_1.png" alt="" slot="prefix" />
              <div class="get-code" v-if="changess" @click.stop="getCode('train_login')" slot="suffix"
                style="color: #e60012">
                获取验证码
              </div>
              <div class="get-code" v-else slot="suffix">
                {{ second }}S后重试
              </div>
            </a-input>
          </div>
          <div class="handoff" style="padding-bottom: 0">
            <span @click.stop="goLogin">密码登录</span>
            <div class="login-centen-right-bottom" @click="goLogon">
              <span>没有账号？去</span>
              <span>注册</span>
            </div>
          </div>
          <div class="login-centen-right-button" @click.stop="login(false)">
            登录
          </div>
        </div>
        <!-- 注册 -->
        <div class="login-centen-right" v-if="is == 3">
          <div class="login-centen-right-title" style="margin-bottom: 18px" v-if="windowWidth() > 767">
            注册
          </div>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
            <a-form-model-item prop="phone" style="margin-bottom: 6px">
              <div class="components-input-demo-presuffix">
                <a-input v-model="ruleForm.phone" placeholder="请输入手机号" allow-clear>
                  <img src="@/assets/img/圆角矩形_4.png" alt="" slot="prefix" />
                </a-input>
              </div>
            </a-form-model-item>
            <div class="components-input-demo-presuffix" style="margin-bottom: 6px">
              <a-input v-model="code" placeholder="请输入验证码">
                <img src="@/assets/img/形状_1.png" alt="" slot="prefix" />
                <div class="get-code" v-if="changess" @click.stop="getCode('train_register')" slot="suffix"
                  style="color: #e60012">
                  获取验证码
                </div>
                <div class="get-code" v-else slot="suffix">
                  {{ second }}S后重试
                </div>
              </a-input>
            </div>
            <a-form-model-item prop="password" style="margin-bottom: 6px">
              <div class="components-input-demo-presuffix">
                <a-input-password v-model="ruleForm.password" placeholder="请输入密码" allow-clear>
                  <img src="@/assets/img/圆角矩形_6.png" alt="" slot="prefix" />
                  <img src="@/assets/img/形状_1 (1).png" alt="" slot="suffix" />
                </a-input-password>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="passwords" style="margin-bottom: 6px">
              <div class="components-input-demo-presuffix">
                <a-input-password v-model="ruleForm.passwords" placeholder="请输入密码" allow-clear>
                  <img src="@/assets/img/圆角矩形_6.png" alt="" slot="prefix" />
                  <img src="@/assets/img/形状_1 (1).png" alt="" slot="suffix" />
                </a-input-password>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="name" style="margin-bottom: 6px">
              <div class="components-input-demo-presuffix">
                <a-input v-model="ruleForm.name" placeholder="请输入姓名" style="padding-left: 10px"></a-input>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="sov" style="margin-bottom: 6px">
              <div class="select">
                <span class="span">身份</span>
                <a-select :options="options" style="width: 322px" v-model="ruleForm.sov" @change="sovChange">
                  <!-- <img
                    src="@/assets/img/＞_拷贝_7.png"
                    alt=""
                    slot="suffixIcon"
                  /> -->
                </a-select>
              </div>
            </a-form-model-item>
            <div class="sex">
              <div class="sex-left">性别</div>
              <div class="sex-right">
                <div class="sex-right-sex" @click="handoffSex(true)" :style="{ 'margin-right': '26px' }">
                  <img src="@/assets/img/radio_red.png" alt="" v-if="sex" />
                  <img src="@/assets/img/radio_bai.png" alt="" v-else />
                  <span>男</span>
                </div>
                <div class="sex-right-sex" @click="handoffSex(false)">
                  <img src="@/assets/img/radio_red.png" alt="" v-if="!sex" />
                  <img src="@/assets/img/radio_bai.png" alt="" v-else />
                  <span>女</span>
                </div>
              </div>
            </div>
            <div class="handoff" :style="{
              margin: windowWidth() > 767 ? '0' : '0 0 23px 0',
            }">
              <div class="login-centen-right-bottom" @click="goLogin">
                <span>已有账号？去</span>
                <span>登录</span>
              </div>
            </div>
            <div class="login-centen-right-button" :style="{ margin: windowWidth() > 767 ? '0' : '0 0 13px 0' }"
              @click="enroll">
              注册
            </div>
            <a-form-model-item prop="agreement" style="margin-bottom: 6px">
              <div class="checkbox">
                <a-checkbox style="width: 322px" v-model="ruleForm.agreement">
                  <p class="p">
                    已阅读并同意
                    <span @click.stop="openModal(2)">《用户协议》</span>
                    和
                    <span @click.stop="openModal(3)">《隐私政策》</span>
                  </p>
                </a-checkbox>
              </div>
            </a-form-model-item>
          </a-form-model>
        </div>
        <!-- 忘记密码 -->
        <div class="login-centen-right" v-if="is == 4">
          <div class="login-centen-right-title">忘记密码</div>
          <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
            <a-form-model-item prop="phone" :style="{
              'margin-bottom': windowWidth() > 767 ? '26px' : '11px',
            }">
              <div class="components-input-demo-presuffix">
                <a-input v-model="ruleForm.phone" placeholder="请输入手机号" allow-clear>
                  <img src="@/assets/img/圆角矩形_4.png" alt="" slot="prefix" />

                  <!-- <img
                    src="@/assets/img/x_拷贝.png"
                    alt=""
                    slot="suffix"
                    @click.stop="clearPhone"
                    style="cursor: pointer"
                  /> -->
                </a-input>
              </div>
            </a-form-model-item>
            <div class="components-input-demo-presuffix" :style="{
              'margin-bottom': windowWidth() > 767 ? '26px' : '11px',
            }">
              <a-input v-model="code" placeholder="请输入验证码">
                <img src="@/assets/img/形状_1.png" alt="" slot="prefix" />
                <div class="get-code" v-if="changess" @click.stop="getCode('train_reset')" slot="suffix"
                  style="color: #e60012">
                  获取验证码
                </div>
                <div class="get-code" v-else slot="suffix">
                  {{ second }}S后重试
                </div>
              </a-input>
            </div>
            <a-form-model-item prop="password" :style="{
              'margin-bottom': windowWidth() > 767 ? '26px' : '11px',
            }">
              <div class="components-input-demo-presuffix">
                <a-input-password v-model="ruleForm.password" placeholder="请输入密码" allow-clear>
                  <img src="@/assets/img/圆角矩形_6.png" alt="" slot="prefix" />
                  <img src="@/assets/img/形状_1 (1).png" alt="" slot="suffix" />
                </a-input-password>
              </div>
            </a-form-model-item>
            <a-form-model-item prop="passwords" style="margin-bottom: 0px">
              <div class="components-input-demo-presuffix">
                <a-input-password v-model="ruleForm.passwords" placeholder="请重复新密码" allow-clear>
                  <img src="@/assets/img/圆角矩形_6.png" alt="" slot="prefix" />
                  <img src="@/assets/img/形状_1 (1).png" alt="" slot="suffix" />
                </a-input-password>
              </div>
            </a-form-model-item>
          </a-form-model>
          <div class="handoff" style="padding-bottom: 0"
            :style="{ 'justify-content': windowWidth() > 767 ? '' : 'center' }">
            <div class="login-centen-right-bottom" @click="goLogin">
              <span>已有账号？去</span>
              <span>登录</span>
            </div>
          </div>
          <div class="login-centen-right-button" @click.stop="confirm">
            确认
          </div>
        </div>
      </div>
    </div>
    <!-- 弹出框 -->
    <van-popup v-model="show" position="bottom" round :style="{ height: '65%' }">
      <div class="popup">
        <p>用户协议和隐私政策</p>
        <div class="popup-conten">
          欢迎来到西顿照明！<br />
          1.为了向您提供产品与服务，我们会根据您服务的具体需要，收集必要的信息，未经您授权，我们不会与第三方共享或外提供您的信息；<br />
          2.请务必请您仔细阅读
          <span>《用户使用协议》</span>以及<span>《隐私政策》</span>
          。如您未满18周岁，请您在您的法定监护人陪同下，仔细阅读并充分理解本协议；<br />
          点击“同意”即表示您已阅读并同意所有条款，若选择不同意，将无法使用我们的产品和服务。
        </div>
        <div class="popup-button">
          <div class="popup-button-left" @click.stop="yesOrNo(false)">
            不同意
          </div>
          <div class="popup-button-right" @click.stop="yesOrNo(true)">同意</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  $login,
  $send_code,
  $register,
  $get_identity,
  $change_password,
  $resetpwd,
  $mobile_login,
} from "@/api";
import { message } from "ant-design-vue";
import { mapState } from "vuex";
export default {
  data () {
    // 手机号验证规则
    let checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入手机号"));
      } else {
        let phoneZZ =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if (!phoneZZ.test(value)) {
          callback(new Error("请输入正确的手机号格式"));
        } else {
          callback();
        }
      }
    };
    // 密码验证规则
    let checkPassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        let passwordZZ = /^.{6,12}$/;
        if (!passwordZZ.test(value)) {
          callback(new Error("密码为6-12位"));
        } else {
          callback();
        }
      }
    };
    // 确认密码验证规则
    let checkPasswords = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        if (value != this.ruleForm.password) {
          callback(new Error("两次密码不一致"));
        } else {
          callback();
        }
      }
    };
    // 姓名验证规则
    let checkName = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };
    // 协议验证规则
    let checkAgreement = (rule, value, callback) => {
      if (!value) {
        if (this.windowWidth() < 767) {
          this.show = true;
        } else {
          callback(new Error("请勾选协议"));
        }
      } else {
        callback();
      }
    };
    return {
      // 表单数据
      ruleForm: {
        phone: "", // 手机号
        password: "", // 密码
        passwords: "", // 确认密码
        name: "", // 姓名
        sov: "", // 身份
        agreement: false, // 协议
      },
      // 表单验证规则
      rules: {
        phone: [{ validator: checkPhone, trigger: "change" }],
        password: [{ validator: checkPassword, trigger: "change" }],
        passwords: [{ validator: checkPasswords, trigger: "change" }],
        name: [{ validator: checkName, trigger: "change" }],
        sov: [
          {
            required: true,
            message: "请选择身份",
            trigger: "change",
          },
        ],
        agreement: [{ validator: checkAgreement, trigger: "blur" }],
      },
      is: 1, //  密码登录1 验证码登录2 注册3 忘记密码4
      code: "", // 验证码
      second: 59, // 获取验证码时的倒计时数字
      changess: true, // 控制 获取验证码或倒计时 的显示
      // 身份的选择器数据
      options: [],
      sex: true, // 性别 true男 false女
      show: false, // 控制 对话框的显示/隐藏 协议和隐私
    };
  },
  async mounted () {
    try {
      let res = await $get_identity();
      this.options = res.data.map((item) => ({
        value: item.id,
        label: item.identity_name,
      }));
    } catch (error) { }
  },
  computed: {
    ...mapState("permissions", ["mid"]),
  },
  watch: {
    is () {
      this.changess = true;
    },
  },
  methods: {
    // 选择器(身份)change
    sovChange () {
      this.$refs.ruleForm.validateField("sov", (errorMsgs) => {
        if (condition) {
          console.log("身份验证不通过");
        } else {
          console.log("身份验证通过");
        }
      });
    },
    // 点击按钮清除密码
    clearPassword () {
      this.ruleForm.password = "";
    },
    // 点击按钮清除手机号
    clearPhone () {
      this.ruleForm.phone = "";
    },

    goHome () {
      this.$router.push({ name: "Home" });
    },
    // 点击去登录
    goLogin () {
      this.is = 1;
    },
    // 点击验证码登录
    Captcha () {
      this.is = 2;
    },
    // 点击去注册
    goLogon () {
      this.is = 3;
    },
    // 点击忘记密码
    ForgotPassword () {
      this.is = 4;
    },
    // 点击获取验证码
    async getCode (event) {
      //在这之前调用接口获取验证码，此操作只是实现倒计时效果
      try {
        let res = await $send_code({ mobile: this.ruleForm.phone, event });
      } catch (error) {
        if (this.windowWidth() > 767) {
          message.error(error.msg, 5);
          return;
        } else {
          this.$toast.fail(error.msg);
          return;
        }
      }
      this.changess = false;
      this.second = 59;
      var interval = setInterval(() => {
        --this.second;
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        this.changess = true;
      }, 60000);
    },
    // 登录
    login (Boole) {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            let res = "";
            let params = {};
            if (Boole) {
              params = {
                account: this.ruleForm.phone,
                password: this.ruleForm.password,
              };
              res = await $login(params);
              localStorage.setItem("token", res.data.userinfo.token);
            } else {
              params = {
                mobile: this.ruleForm.phone,
                captcha: this.code,
              };
              res = await $mobile_login(params);
              localStorage.setItem("token", res.data.token);
            }
            console.log(res);
            // return;
            if (this.windowWidth() > 767) {
              message.success("登录成功", 1);
            } else {
              this.$toast.success("登录成功");
            }
            setTimeout(() => {
              this.$router.push({ name: "Home" });
            }, 1500);
          } catch (error) {
            if (this.windowWidth() > 767) {
              message.error(error.msg, 5);
            } else {
              this.$toast.fail(error.msg);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 注册
    enroll () {
      let verifyNumber = 0;
      this.$refs.ruleForm.validateField(
        ["phone", "password", "passwords", "name", "sov"],
        (errorMsgs) => {
          if (errorMsgs) {
            console.log("其他验证不通过");
          } else {
            verifyNumber++;
            if (verifyNumber == 5) {
              this.$refs.ruleForm.validateField("agreement", async (error) => {
                if (error) {
                  console.log("协议验证不通过");
                } else {
                  console.log("协议验证通过");
                  try {
                    let params = {
                      mobile: this.ruleForm.phone,
                      captcha: this.code,
                      password: this.ruleForm.password,
                      confirmpw: this.ruleForm.passwords,
                      identity: this.ruleForm.sov,
                      real_name: this.ruleForm.name,
                      gender: this.sex ? 1 : 2,
                      mount_id: this.mid,
                    };
                    let res = await $register(params);
                    if (this.windowWidth() > 767) {
                      message.success("注册成功", 1);
                    } else {
                      this.$toast.success("注册成功");
                    }
                    setTimeout(() => {
                      this.is = 1;
                    }, 1500);
                  } catch (error) {
                    if (this.windowWidth() > 767) {
                      message.error(error.msg, 5);
                    } else {
                      this.$toast.fail(error.msg);
                    }
                  }
                }
              });
            }
          }
        }
      );
    },
    // 点击 忘记密码的 确认按钮
    confirm () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            let params = {
              mobile: this.ruleForm.phone,
              captcha: this.code,
              new_psw: this.ruleForm.password,
              confirm_psw: this.ruleForm.passwords,
            };
            // return;
            let res = await $resetpwd(params);
            if (this.windowWidth() > 767) {
              message.success("修改密码成功", 1);
            } else {
              this.$toast.success("修改密码成功");
            }
            setTimeout(() => {
              this.is = 1;
            }, 1500);
          } catch (error) {
            if (this.windowWidth() > 767) {
              message.error(error.msg, 5);
            } else {
              this.$toast.fail(error.msg);
            }
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 切换性别
    handoffSex (bolle) {
      if (bolle == this.sex) {
        return;
      }
      this.sex = !this.sex;
    },
    // 打开对话框 协议和隐私
    openModal (id) {
      if (this.windowWidth() < 767) {
        this.show = true;
      } else {
        this.$router.push({ name: "feedbackFile", query: { id } });
      }
    },
    // 同意/不同意
    yesOrNo (is) {
      if (is) {
        this.show = false;
        this.ruleForm.agreement = true;
      } else {
        this.show = false;
        this.ruleForm.agreement = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
// PC样式
@media (min-width: 767px) {
  .login {
    width: 100vw;
    height: 100vh;
    background-image: url("~@/assets/img/图层_9.png");
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;

    .login-top {
      width: 160px;
      height: 20px;
      object-fit: cover;
      margin-bottom: 27px;
      cursor: pointer;
    }

    .login-centen {
      height: 680px;
      width: 1000px;
      display: flex;

      .login-centen-img {
        width: 554px;
        object-fit: cover;
      }

      .login-centen-right {
        background: #ffffff;
        flex: 1;
        padding: 37px 62px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .login-centen-right-title {
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
          text-align: center;
          margin-bottom: 55px;
        }

        .components-input-demo-presuffix {
          /deep/.ant-input {
            width: 322px;
            height: 53px;
            padding-left: 42px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #a9a9a9;
          }

          .get-code {
            cursor: pointer;
          }
        }

        .sex {
          height: 50px;
          padding: 18px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #dedede;
          border-radius: 4px;

          .sex-left {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .sex-right {
            display: flex;

            .sex-right-sex {
              display: flex;
              align-items: center;
              cursor: pointer;

              img {
                width: 18px;
                height: 18px;
                margin-right: 4px;
              }

              span {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
              }
            }
          }
        }

        .handoff {
          display: flex;
          justify-content: space-between;
          padding: 13px;
          margin-bottom: 31px;

          span {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            cursor: pointer;
          }
        }

        .login-centen-right-button {
          width: 322px;
          height: 53px;
          background: #e60012;
          border-radius: 4px;
          font-size: 22px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .login-centen-right-bottom {
          display: flex;
          justify-content: center;

          span:nth-child(1) {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          span:nth-child(2) {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #e60012;
            cursor: pointer;
          }
        }

        .select {
          position: relative;

          /deep/.ant-select-selection--single {
            height: 53px;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .ant-select-selection__rendered {
              margin-right: 38px;
            }

            .ant-select-selection-selected-value {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #a9a9a9;
              padding-bottom: 4px;
              padding-right: 13px;
            }
          }

          .span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 13px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            z-index: 1;
          }
        }

        .radio {
          width: 322px;
          height: 53px;
          background: #ffffff;
          border: 1px solid #dedede;
          border-radius: 4px;
          display: flex;
          align-items: center;
          position: relative;

          /deep/.ant-radio-group {
            display: flex;
            justify-content: flex-end;
          }

          .span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 13px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            z-index: 1;
          }
        }

        .checkbox {
          width: 322px;
          position: relative;

          /deep/.ant-checkbox-wrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          /deep/.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #fff;
            border-color: #8c8c8c;
          }

          /deep/.ant-checkbox-checked .ant-checkbox-inner::after {
            border-color: #e60012;
          }

          /deep/.ant-checkbox-checked::after {
            border-color: #8c8c8c;
          }

          /deep/.ant-checkbox-wrapper:hover .ant-checkbox-inner,
          .ant-checkbox:hover .ant-checkbox-inner,
          .ant-checkbox-input:focus+.ant-checkbox-inner {
            border-color: #8c8c8c;
          }

          .p {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            margin-bottom: 0;
            padding-bottom: 5px;

            span {
              color: #333333;
            }
          }
        }
      }
    }
  }
}

// H5样式
@media (max-width: 767px) {
  .login {
    width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: center;

    .login-top {
      width: 147px;
      height: 20px;
      margin: 0 auto;
      // margin-bottom: 67px;
      // margin-top: 104px;
      margin-bottom: 47px;
      margin-top: 42px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .login-centen {
      padding: 0 35px;

      .login-centen-img {
        display: none;
      }

      .login-centen-right {
        .login-centen-right-title {
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #333333;
          margin-bottom: 23px;
        }

        .components-input-demo-presuffix {
          /deep/.ant-input {
            width: 322px;
            height: 53px;
            padding-left: 42px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #a9a9a9;
            background: #f7f8fa;
          }
        }

        /deep/.ant-form-item {
          margin-bottom: 0;
        }

        .sex {
          height: 50px;
          background: #f7f8fa;
          padding: 18px 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .sex-left {
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          .sex-right {
            display: flex;

            .sex-right-sex {
              display: flex;
              align-items: center;
              cursor: pointer;

              img {
                width: 18px;
                height: 18px;
                margin-right: 4px;
              }

              span {
                font-size: 15px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #666666;
              }
            }
          }
        }

        .handoff {
          display: flex;
          justify-content: space-between;
          padding: 13px;
          padding-bottom: 0;
          margin-bottom: 23px;

          span {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            cursor: pointer;
          }
        }

        .login-centen-right-button {
          width: 306px;
          height: 50px;
          background: #e60012;
          border-radius: 4px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 24px;
          cursor: pointer;
        }

        .login-centen-right-bottom {
          display: flex;
          justify-content: center;

          span:nth-child(1) {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
          }

          span:nth-child(2) {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #e60012;
            cursor: pointer;
          }
        }

        .select {
          position: relative;

          /deep/.ant-select-selection--single {
            height: 53px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            background: #f7f8fa;

            .ant-select-selection__rendered {
              margin-right: 30px;
            }

            .ant-select-selection-selected-value {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #a9a9a9;
              padding-bottom: 2px;
              padding-right: 3px;
            }
          }

          .span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 13px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            z-index: 1;
          }
        }

        .radio {
          width: 322px;
          height: 53px;
          background: #ffffff;
          border: 1px solid #dedede;
          border-radius: 4px;
          display: flex;
          align-items: center;
          position: relative;
          background: #f7f8fa;

          /deep/.ant-radio-group {
            display: flex;
            justify-content: flex-end;
          }

          .span {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 13px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;
            z-index: 1;
          }
        }

        .checkbox {
          width: 322px;
          position: relative;

          /deep/.ant-checkbox-wrapper {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            line-height: 0;
            margin-bottom: 79px;
          }

          /deep/.ant-checkbox-checked .ant-checkbox-inner {
            background-color: #fff;
            border-color: #8c8c8c;
          }

          /deep/.ant-checkbox-checked .ant-checkbox-inner::after {
            border-color: #e60012;
          }

          /deep/.ant-checkbox-checked::after {
            border-color: #8c8c8c;
          }

          /deep/.ant-checkbox-wrapper:hover .ant-checkbox-inner,
          .ant-checkbox:hover .ant-checkbox-inner,
          .ant-checkbox-input:focus+.ant-checkbox-inner {
            border-color: #8c8c8c;
          }

          .p {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #999999;
            margin-bottom: 0;
            padding-bottom: 5px;

            span {
              color: #333333;
            }
          }
        }
      }
    }

    .popup {
      padding: 40px 14px;

      p {
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #333333;
        margin-bottom: 29px;
      }

      .popup-conten {
        font-size: 13px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #999999;

        span {
          color: #ff7608;
        }

        margin-bottom: 39px;
      }

      .popup-button {
        margin: 0 9px;
        display: flex;

        .popup-button-left {
          width: 155px;
          height: 51px;
          background: #ffffff;
          border: 1px solid #c9c9c9;
          border-radius: 5px;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #333333;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 18px;
        }

        .popup-button-right {
          width: 155px;
          height: 51px;
          background: #ea4949;
          border-radius: 5px;
          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 800;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
